import { produce, setAutoFreeze } from 'immer'
import { actions } from './actions'

setAutoFreeze(false)

const initialState = {
  etiquetasFamilia: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function etiquetaFamiliaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.ETIQUETA_FAMILIA_LOAD_REQUESTED:
      return {
        ...state,
        etiquetasFamilia: { ...state.etiquetasFamilia, data: null, loading: true },
      }
    case actions.ETIQUETA_FAMILIA_LOAD_SUCCEEDED:
      return {
        ...state,
        etiquetasFamilia: {
          ...state.etiquetasFamilia,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.ETIQUETA_FAMILIA_LOAD_FAILED:
      return {
        ...state,
        etiquetasFamilia: { ...state.etiquetasFamilia, loading: false, error: action.error },
      }
    case actions.ETIQUETA_FAMILIA_INSERT_REQUESTED:
      return {
        ...state,
        etiquetasFamilia: { ...state.etiquetasFamilia, loading: true },
      }

    case actions.ETIQUETA_FAMILIA_INSERT_SUCCEEDED: {
      const insertedEtiqueta = action.payload
      const newState = produce(state, draftState => {
        draftState.etiquetasFamilia.data.push(insertedEtiqueta)
        draftState.etiquetasFamilia.data = [...draftState.etiquetasFamilia.data].sort(
          (a, b) => a.orden - b.orden,
        )
        draftState.etiquetasFamilia.loading = false
      })
      return newState
    }
    case actions.ETIQUETA_FAMILIA_INSERT_FAILED:
      return {
        ...state,
        etiquetasFamilia: { ...state.etiquetasFamilia, loading: false, error: action.error },
      }
    case actions.ETIQUETA_FAMILIA_UPDATE_REQUESTED:
      return {
        ...state,
        etiquetasFamilia: { ...state.etiquetasFamilia, loading: true },
      }

    case actions.ETIQUETA_FAMILIA_UPDATE_SUCCEEDED: {
      const updatedEtiqueta = action.payload
      const newState = produce(state, draftState => {
        const index = draftState.etiquetasFamilia.data.findIndex(e => e.id === updatedEtiqueta.id)
        draftState.etiquetasFamilia.data[index] = updatedEtiqueta
        draftState.etiquetasFamilia.loading = false
      })
      return newState
    }
    case actions.ETIQUETA_FAMILIA_UPDATE_FAILED:
      return {
        ...state,
        etiquetasFamilia: { ...state.etiquetasFamilia, loading: false, error: action.error },
      }
    case actions.ETIQUETA_FAMILIA_DELETE_REQUESTED:
      return {
        ...state,
        etiquetasFamilia: { ...state.etiquetasFamilia, loading: true },
      }
    case actions.ETIQUETA_FAMILIA_DELETE_SUCCEEDED: {
      return {
        ...state,
        etiquetasFamilia: {
          ...state.etiquetasFamilia,
          data: state.etiquetasFamilia.data.filter(d => action.payload !== d.id),
          loading: false,
          reload: false,
        },
      }
    }
    case actions.ETIQUETA_FAMILIA_DELETE_FAILED:
      return {
        ...state,
        etiquetasFamilia: {
          ...state.etiquetasFamilia,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
